import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { nextTick, onMounted, provide, ref } from "vue";
import { useStore } from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import { themeMode } from "@/layouts/backend-layout/config/config";
import { initializeComponents } from "@/core/plugins/plugins";
import { useRouter } from "vue-router";
import UserDetails from "@/projects/tenant/components/UserDetails.vue";
import CommentView from "@/projects/tenant/components/CommentView.vue";
import UserFileDocModal from "@/components/UserFileDocModal.vue";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";
import ConfirmBox from "@/components/ConfirmBox.vue";
import RejectReasonBox from "@/components/RejectReasonBox.vue";
import AddCommentModal from "@/components/modal/AddCommentModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TenantApp',
  setup(__props) {

const addCommentModalRef = ref<InstanceType<typeof AddCommentModal>>();
const router = useRouter();
const globalUserShowRef = ref<InstanceType<typeof UserDetails>>();
const globalCommentViewRef = ref<InstanceType<typeof CommentView>>();
const userFileDocModalRef = ref<InstanceType<typeof UserFileDocModal>>();
const confirmBoxRef = ref<InstanceType<typeof ConfirmBox>>();
const rejectReasonBoxRef = ref<InstanceType<typeof RejectReasonBox>>();

onMounted(async () => {
  // check if current user is authenticated
  // console.log(globalUserShowRef.value);
  // console.log(userFileDocModalRef.value);
  const store = useStore();
  provide(InjectKeys.OPEN_FILE_MODAL, userFileDocModalRef.value?.show);
  provide(InjectKeys.OPEN_USER_DETAILS, globalUserShowRef.value?.show);
  provide(InjectKeys.OPEN_COMMENT_VIEW, globalCommentViewRef.value?.show);
  provide(InjectKeys.OPEN_CONFIRM_MODAL, confirmBoxRef.value?.show);
  provide(InjectKeys.OPEN_REJECT_REASON_MODAL, rejectReasonBoxRef.value?.show);
  provide(InjectKeys.FILE_SHOW_REF, userFileDocModalRef);
  provide(InjectKeys.OPEN_ADD_COMMENT_MODAL, addCommentModalRef.value?.show);
  if (!store.state.AuthModule?.isAuthenticated) {
    await router.push({ name: "sign-in" });
  } else {
    if (!store.state.AuthModule?.hasUserVerified2Fa) {
      await router.push({ name: "2fa" });
    }
  }
  /**
   * Overrides the layout config using saved data from localStorage
   * remove this to use static config (@/core/config/DefaultLayoutConfig.ts)
   */
  store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);
  /**
   *  Sets a mode from configuration
   */
  if (themeMode.value === undefined) {
    await store.dispatch(Actions.SET_THEME_MODE_ACTION, "light");
  } else {
    await store.dispatch(Actions.SET_THEME_MODE_ACTION, themeMode.value);
  }

  nextTick(() => {
    initializeComponents();
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(UserDetails, {
      ref_key: "globalUserShowRef",
      ref: globalUserShowRef
    }, null, 512),
    _createVNode(CommentView, {
      ref_key: "globalCommentViewRef",
      ref: globalCommentViewRef
    }, null, 512),
    _createVNode(UserFileDocModal, {
      ref_key: "userFileDocModalRef",
      ref: userFileDocModalRef
    }, null, 512),
    _createVNode(ConfirmBox, {
      ref_key: "confirmBoxRef",
      ref: confirmBoxRef
    }, null, 512),
    _createVNode(RejectReasonBox, {
      ref_key: "rejectReasonBoxRef",
      ref: rejectReasonBoxRef
    }, null, 512),
    _createVNode(AddCommentModal, {
      ref_key: "addCommentModalRef",
      ref: addCommentModalRef
    }, null, 512)
  ], 64))
}
}

})